var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3032 0.929105L0.928805 13.3035C0.440649 13.7916 0.440649 14.5831 0.928805 15.0712C1.41696 15.5594 2.20842 15.5594 2.69657 15.0712L15.0709 2.69687C15.5591 2.20872 15.5591 1.41726 15.0709 0.929105C14.5828 0.440949 13.7913 0.44095 13.3032 0.929105Z",
    fill: "#687188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0708 13.3035L2.69638 0.929127C2.20823 0.440972 1.41677 0.440972 0.928617 0.929127C0.440461 1.41728 0.440461 2.20874 0.928617 2.69689L13.303 15.0713C13.7911 15.5594 14.5826 15.5594 15.0708 15.0713C15.5589 14.5831 15.5589 13.7916 15.0708 13.3035Z",
    fill: "#687188"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.76fa63cd9c204f7e2c326616fdd9e017.svg";
export { ForwardRef as ReactComponent };